import { useRouteMatch } from 'react-router';
import { CampaignList } from './CampaignList/CampaignList';
import { AuthorisedRoute } from 'core/router/AuthorisedRoute';
import { CampaignEditor } from './CampaignEditor/CampaignEditor';

export const BulkRetargetingCampaignSection = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <AuthorisedRoute exact={true} path={`${path}`} component={CampaignList} />
      <AuthorisedRoute path={`${path}/:campaignId`} component={CampaignEditor} />
    </>
  );
};
